import React, { useState, useEffect, useRef } from 'react'
import { ImSearch } from 'react-icons/im';
import { API_ROOT, sendRequest } from '../../supplementary_components/requests';
import { useNavigate } from 'react-router-dom';
import { CustomLoadingIcon } from '../../supplementary_components/loading_icon';
import { BsBox, BsTruckFlatbed, BsBuilding } from "react-icons/bs";
import { priceOnFinish } from '../../supplementary_components/priceInputDelegate';
import { DriverStatusFormatter, DriverStatusColorGenerator } from '../../pages/drivers/driverDataDelegate';
import { loadStatusFormatter, loadStatusColorGenerator } from '../../pages/loads/loadDataDelegate';
import { TrailerSVG } from '../notes/NoteItem';
import { IoMdPerson } from "react-icons/io";
import styles from './header.module.scss';
import { canSeeLoadRates } from '../../supplementary_components/userDataDelegate';

const minCharCountForSearch = 1;

export const SearchBox = ()=> {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(null);
    const [searchText, setSearchText] = useState("");
    const [focused, setFocused] = useState(false);
    const inputRef = useRef();
    const navigate = useNavigate();
    const userCanSeeLoadRates = canSeeLoadRates();
    useEffect(
        () => {
            const controller = new AbortController();
            if(searchText.length > minCharCountForSearch){
                setLoading(true);
                const signal = controller.signal;
                sendRequest('GET', API_ROOT+`search?searchPage=false&pattern=`+searchText, signal, (res)=>{
                    setData(res);
                    setLoading(false);
                }, ()=>{
                    setLoading(false);
                }, null);
            }
            return () => {
                // cancel the request before component unmounts
                controller.abort();
            };
        // eslint-disable-next-line
        }, [searchText]
    );
    
    const keys = data ? Object.keys(data) : [];
    
    return <div className={styles.searchContainer}>
        <div className={styles.searchWrapper}>
            {loading ? <CustomLoadingIcon height={'0.97rem'} speed={1.0} /> : <ImSearch color="var(--gray)" />}
            <input className={styles.searchBoxInput} autoComplete="off" ref={inputRef} id="mainSearchBox" placeholder='Search...' onFocus={()=>{setFocused(true)}} 
            onBlur={()=>{
                setFocused(false);
            }} 
            onKeyDown={(e) => {
                if (e.key === "Enter") {
                    if(searchText !== ""){
                        navigate(`/search?val=${encodeURIComponent(searchText)}`);
                        inputRef.current?.blur();
                    }
                    
                }
            }}
            onChange={(e)=>{
                setSearchText(e.target.value.replace(/\s+/g, ' ').trim());
            }} />
        </div>
        { focused && searchText.length > minCharCountForSearch ?
            <div className={styles.searchSuggestionsContainer}>
                <div><div onMouseDown={(e)=>{
                    e.preventDefault();
                    navigate(`/search?val=${encodeURIComponent(searchText)}`);
                    inputRef.current?.blur();
                }} className="clickable" >Show all results for:{<span>{searchText}</span>}</div></div>
                {
                    keys.length === 0 ? 
                    <>
                    <div>
                        <hr />
                        <div className="noResults">No results...</div>
                    </div>
                    </>
                    :
                    keys.map((key, index) =>{
                        return <div key={index}>
                            <hr />
                            <div className="lbl">{key.toUpperCase()}</div>
                            {
                                data[key].map((value, indx)=>{
                                    if(indx > 4){
                                        return <div key={indx} className='ellipses non-selectable' onMouseDown={(e)=>{
                                            e.preventDefault();}}>...</div>
                                    }
                                    return <div key={indx}  className="clickable" onMouseDown={(e)=>{
                                        e.preventDefault();
                                        navigate(`/${key}/${value.id}`);
                                        inputRef.current?.blur();
                                    }}> <SearchResultOption type={key} value={value} canSeeRates={userCanSeeLoadRates} />
                                    </div>
                                })
                            }
                        </div>
                    })
                }
            </div>
            :
            null
        }
        
    </div>
}
const SearchResultOption = ({type, value, canSeeRates})=>{
    switch (type) {
        case "loads":
            return <><BsBox /><span className="mainInfo">{value.loadNumber}</span>
            {canSeeRates ? <span className="supInfo">({priceOnFinish(value.payout)})</span> : null}
            <span className="alignRight" style={{fontWeight:"600", color:`${loadStatusColorGenerator(value.loadStatus)}`}}>{loadStatusFormatter(value.loadStatus)}</span> </>;
        case "trucks":
            return <><BsTruckFlatbed /><span className="mainInfo">{value.truckNumber}</span>
            <span className="supInfo">({value.currentTrailer ?  `Trailer: ${value.currentTrailer.trailerNumber}`: "Bobtail" })</span> 
            <span className="alignRight" style={{fontWeight:"600", color:`var(${value.status === "Active" ?"--main-color" : value.status === "Sold" ? "--inProgressBlue" : "--alert-color"})`}}>{value.status}</span> </>;
        case "trailers":
            return <><TrailerSVG /><span className="mainInfo">{value.trailerNumber}</span>
            {value.currentTruck ?<span className="supInfo">(Truck: {value.currentTruck})</span> : null }
            <span className="alignRight" style={{fontWeight:"600", color:`var(${value.trailerStatus === "Active" ?"--main-color": "--alert-color"})`}}>{value.trailerStatus === "Active" ? "Active" : "Inactive"}</span> </>;
        case "drivers":
            return <><IoMdPerson /><span className="mainInfo">{`${value.firstName} ${value.middleName || ''} ${value.lastName}`}</span>
            <span className="alignRight" style={{fontWeight:"600", color:DriverStatusColorGenerator(value.driverStatus)}}>{DriverStatusFormatter(value.driverStatus)}</span> </>;
        case "brokers":
            return <><BsBuilding /><span className="mainInfo">{value.brokerageName}</span>
            <span className="alignRight" style={{fontWeight:"600", color:value.approved? 'var(--main-color)':'var(--alert-color)'}}>{value.approved ? "Approved" : "Not Approved"}</span> </>;
        default:
            return <></>;
    }
    
}